import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '../user/user.service';
import { UserModel } from '../user/user.model';
import { SupportTicketsService } from './tickets.service';
import { SupportTicketsModel } from './tickets.model';
import { SUPPORT_PRIORITIES } from './tickets.component';
import { NotificationService } from '../../modules_v2/shared/services/notification.service';

@Component({
    selector: 'app-supportticketsdialog',
    templateUrl: './tickets-dialog.component.html',
    styleUrls: ['./tickets-dialogs.css'],
    standalone: false
})
export class SupportTicketsDialogComponent implements OnInit {
    ticketForm: UntypedFormGroup;
    user: UserModel;
    saving = false;
    submitted = false;

    readonly priorities = SUPPORT_PRIORITIES;
    readonly categories = [
        'Resumen', 'Mi cuenta', 'Conceptos', 'Ingresos', 'Gastos', 'Inversión',
        'Finanzas', 'Personal', 'Contabilidad', 'Fiscalidad', 'Ficheros', 'Otro'
    ];

    constructor(
        public dialogRef: MatDialogRef<SupportTicketsDialogComponent, boolean>,
        private supportTicketsService: SupportTicketsService,
        private userService: UserService,
        private notification: NotificationService,
        private fb: UntypedFormBuilder
    ) { }

    ngOnInit() {
        this.ticketForm = this.fb.group({
            Priority: [1, Validators.required],
            Subject: ['', [Validators.required, Validators.maxLength(150)]],
            Category: [null, Validators.required],
            Message: ['', Validators.required]
        });

        this.userService.loadData()
            .then((userData: UserModel) => { this.user = userData; })
            .catch(() => this.notification.error('No se pudieron cargar los datos del usuario'));
    }

    invalid(control: string): boolean {
        const c = this.ticketForm.get(control);
        return !!c && c.invalid && (c.touched || this.submitted);
    }

    setPriority(value: number) {
        this.ticketForm.get('Priority').setValue(value);
    }

    save() {
        this.submitted = true;
        if (this.ticketForm.invalid || !this.user || this.saving) {
            this.ticketForm.markAllAsTouched();
            return;
        }

        this.saving = true;
        this.dialogRef.disableClose = true;

        const ticket = new SupportTicketsModel();
        ticket.Priority = this.ticketForm.get('Priority').value;
        ticket.Subject = this.ticketForm.get('Subject').value.trim();
        ticket.Category = this.ticketForm.get('Category').value;
        ticket.Message = this.ticketForm.get('Message').value.trim();
        ticket.Name = this.user.username;
        ticket.OwnerUid = this.user.uid;

        this.supportTicketsService.addTicket(ticket)
            .then(() => {
                this.notification.ok('Incidencia enviada. Te responderemos lo antes posible.');
                this.dialogRef.close(true);
            })
            .catch(() => {
                this.saving = false;
                this.dialogRef.disableClose = false;
                this.notification.error('No se pudo enviar la incidencia');
            });
    }

    closeDialog() {
        this.dialogRef.close(false);
    }
}
